import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from "../Component/Header";

const JuniorBoard = () => {
    useEffect(() => {
        document.title = 'Junior Board -  The Air Force School Subroto Park';
    }, []);

    return (
        <>
            <Header />
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>
                    <li> About Us</li>
                    <li>Prefectorial Board</li>
                    <li>Junior Board</li>
                </ul>
            </div>
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1> Junior School </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <h6>THE STUDENT COUNCIL JUNIOR WING 2026-27 is-</h6>
                            <div className="table-responsive maintable">
                                <table className="table">
                                    <thead>
                                        <tr><th>Designation</th><th>Name</th><th>Class &amp; Section</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr><td>HEAD GIRL</td><td>Kimaya Sinha</td><td>V E</td></tr>
                                        <tr><td>HEAD BOY</td><td>Shaurya Bhushan Tiwari</td><td>V A</td></tr>
                                        <tr><td>VICE HEAD GIRL</td><td>Siya Kanwar</td><td>V A</td></tr>
                                        <tr><td>VICE HEAD BOY</td><td>Abhinav Singh Rawat</td><td>V D</td></tr>
                                        <tr><td>SPORTS CAPTAIN (GIRLS)</td><td>Shanaya Singh</td><td>V C</td></tr>
                                        <tr><td>SPORTS CAPTAIN (BOYS)</td><td>Advik Shukla</td><td>V D</td></tr>
                                        <tr><td>VICE SPORTS CAPTAIN (GIRLS)</td><td>S. Srishtika</td><td>V D</td></tr>
                                        <tr><td>VICE SPORTS CAPTAIN (BOYS)</td><td>Mayank Basor</td><td>V C</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="table-responsive maintable">
                                <table className="table">
                                    <thead><tr><th></th><th>SUBROTO HOUSE</th><th>ARJAN HOUSE</th><th>LATIF HOUSE</th></tr></thead>
                                    <tbody>
                                        <tr><td>HOUSE CAPTAIN</td><td>Sharvil Singh Nagar (VD)</td><td>Aaviral Arora (VB)</td><td>Tanisha Sathvik (VD)</td></tr>
                                        <tr><td>HOUSE VICE CAPTAIN</td><td>Avanya Kapoor (VB)</td><td>Sia Verma (VA)</td><td>Veeha Mudgal (VC)</td></tr>
                                        <tr><td>PREFECT</td><td>Aradhyaa Kr. Verma (VA)</td><td>Navya Tanwar (VC)</td><td>Jaden Joah Rodrigues (VA)</td></tr>
                                        <tr><td>PREFECT</td><td>Bhavya Upreti (VE)</td><td>Aakash Singh Yadav (VD)</td><td>Saanvi Singh (VB)</td></tr>
                                        <tr><td>PREFECT</td><td>Rishabh Das (VC)</td><td>Shivranjini Rathore (VE)</td><td>Aradhya Ojha (VE)</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="table-responsive maintable">
                                <table className="table">
                                    <thead><tr><th></th><th>PRATAP HOUSE</th><th>KATRE HOUSE</th></tr></thead>
                                    <tbody>
                                        <tr><td>HOUSE CAPTAIN</td><td>Yashaswini Singh (VB)</td><td>Yaanvi Yadav (VA)</td></tr>
                                        <tr><td>HOUSE VICE CAPTAIN</td><td>Jasleen Gehlawat (VA)</td><td>Aniket Raj Singh (VE)</td></tr>
                                        <tr><td>PREFECT</td><td>Rudra Kodhar (VC)</td><td>Garvit Yadav (VB)</td></tr>
                                        <tr><td>PREFECT</td><td>Soumili Nath (VD)</td><td>Ishwin Kaur Gujral (VC)</td></tr>
                                        <tr><td>PREFECT</td><td>Vani Mishra (VE)</td><td>Rishani Narang (VD)</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default JuniorBoard;
